import React from 'react';
import { useDispatch } from 'react-redux';
import '../common/cardView.scss';
import './quizCard.scss';
import QuizDetails from "./QuizDetails";
import QuizHeader from "./QuizHeader";
import QuizCardButtons from "./QuizCardButtons";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import QuizCardLoader from "../common/loaders/QuizCardLoader";
import { toggleSavedQuiz } from "examsbook-react-sdk/actions/toggleSavedQuiz";
import CardBgImg from "../../assets/images/quiz-card-test-img.png";

/**
 * Quiz card. This component  is used application wide.
 */

function QuizCard(props) {
    const { quizData, singleTestSeriesLoading } = props;
    const t = useTranslations();
    const dispatch = useDispatch();

    function renderList() {
        return (
            <div className="card-list quiz-list">
                <img src={CardBgImg} alt="" className="quiz-card-img"/>
                <QuizHeader quizData={quizData} toggleQuizSave={() => unSaveQuiz(quizData)}/>
                <QuizDetails t={t} quizData={quizData}/>
                <QuizCardButtons t={t} quizData={quizData}/>
            </div>
        );
    }

    function unSaveQuiz(quiz) {
        dispatch(toggleSavedQuiz(quiz._id));
    }

    function renderLoader() {
        //we will show four cards to fill this space.
        return (
            <div className="card-view">
                <div className="card-list-view">
                    <QuizCardLoader/>
                    <QuizCardLoader/>
                    <QuizCardLoader/>
                    <QuizCardLoader/>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {
                !singleTestSeriesLoading ? renderList() : renderLoader()
            }
        </React.Fragment>
    );
}

export default QuizCard;
